import PropTypes from 'prop-types';
import React from 'react';
// -*- mode: jsx;-*-
import {
    extensionReasons,
    teacherDraftableProjectCategories,
    teacherSupportCategoriesWithGiftCodeInputs,
    teacherSupportCategoriesWithoutSignIn,
    teacherSupportCategoriesWithPromoCodeInput,
    teacherSupportCategoriesWithResourceInputs,
    teacherSupportCategoriesWithResourceIssueInputs,
    teacherSupportCategoriesWithSchoolAddressInput,
    teacherSupportCategoriesWithTYPExtensionInput,
} from './contactConstants.js';
import TeacherFormProjectFields from './TeacherFormProjectFields.js';
import CategorySelectors from './CategorySelectors.js';
import { DatePicker } from './DatePicker.js';
import { ResourceSelectors } from './ResourceSelectors.js';
import TextField from './TextField.js';
import DynamicGiftCodeInputList from './DynamicGiftCodeInputList.js';
import { _pad } from '../common/timeUtil.js';
import { LoadingEllipsis } from '../common/LoadingEllipsis.js';

/* global dcAnalytics */ // Defined in JSP -> templates:backend-main -> templates:shared-main -> constants.jsp -> general.js <- dcAnalytics.js

export default class TeacherContactForm extends React.Component {
    displayFAQ() {
        if (this.props.chosenSupportCategory.faq) {
            return (
                <div className="support-faq-container">
                    <div className="supportFaq" dangerouslySetInnerHTML={{ __html: this.props.chosenSupportCategory.faq }}/>
                </div>
            );
        }
    }

    renderUserInfoFields() {
        if (this.props.loggedInUser) {
            return (
                <div>
                    <input type="hidden" name="userId" value={this.props.formData.userId}/>
                    <input type="hidden" name="schoolId" value={this.props.formData.schoolId}/>
                    <input type="hidden" name="first" value={this.props.formData.first}/>
                    <input type="hidden" name="last" value={this.props.formData.last} />
                    <input type="hidden" name="email" value={this.props.formData.email} />
                    <input type="hidden" name="schoolName" value={this.props.formData.schoolName} />
                    <input type="hidden" name="schoolAddress1" value={this.props.formData.schoolAddress1} />
                    <input type="hidden" name="schoolCity" value={this.props.formData.schoolCity} />
                    <input type="hidden" name="schoolState" value={this.props.formData.schoolState} />
                    <input type="hidden" name="schoolZip" value={this.props.formData.schoolZip} />
                    <input type="hidden" name="homePhone" value={this.props.formData.homePhone}/>
                </div>
            );
        } else {
            return (
                <div>
                    <TextField label="Email address" name="email" value={this.props.formData.email}
                        inputType="email"
                        inputChangeCallback={this.props.callbacks.handleInputChange}
                        inputBlurCallback={this.props.callbacks.findUserByUserName}
                        errorMessage={this.props.formErrors.email} />
                    <TextField label="First name" name="first" value={this.props.formData.first}
                        inputChangeCallback={this.props.callbacks.handleInputChange}
                        errorMessage={this.props.formErrors.first} />
                    <TextField label="Last name" name="last" value={this.props.formData.last}
                        inputChangeCallback={this.props.callbacks.handleInputChange}
                        errorMessage={this.props.formErrors.last} />
                    <TextField label="School name" name="schoolName" value={this.props.formData.schoolName}
                        inputChangeCallback={this.props.callbacks.handleInputChange}
                        errorMessage={this.props.formErrors.schoolName} />
                </div>
            );
        }
    }

    renderSchoolInfoFields() {
        if (teacherSupportCategoriesWithSchoolAddressInput[this.props.chosenSupportCategory.keyword]) {
            if (!this.props.loggedInUser) {
                return (
                    <div>
                        <TextField label={'School street address'} name={'schoolAddress1'} value={this.props.formData.schoolAddress1}
                            inputChangeCallback={this.props.callbacks.handleInputChange}
                            errorMessage={this.props.formErrors.schoolAddress1} />
                        <div id="cityState">
                            <TextField label={'City'} name={'schoolCity'} value={this.props.formData.schoolCity}
                                inputChangeCallback={this.props.callbacks.handleInputChange}
                                errorMessage={this.props.formErrors.schoolCity} />
                            <TextField label={'State'} name={'schoolState'} value={this.props.formData.schoolState}
                                inputChangeCallback={this.props.callbacks.handleInputChange}
                                errorMessage={this.props.formErrors.schoolState} />
                            <TextField label={'Zip code'} name={'schoolZip'} value={this.props.formData.schoolZip}
                                inputChangeCallback={this.props.callbacks.handleInputChange}
                                errorMessage={this.props.formErrors.schoolZip} />
                        </div>
                    </div>
                );
            }
        }
    }

    renderProjectFields() {
        if (!(teacherSupportCategoriesWithSchoolAddressInput[this.props.chosenSupportCategory.keyword] ||
                teacherSupportCategoriesWithGiftCodeInputs[this.props.chosenSupportCategory.keyword])) {
            return (
                <div className="input-holder">
                    <TeacherFormProjectFields
                        proposalId ={this.props.formData.proposalId}
                        proposalTitle ={this.props.formData.proposalTitle}
                        formErrors={this.props.formErrors}
                        chosenSupportCategory = {this.props.chosenSupportCategory}
                        projects={this.props.projects}
                        filteredProjects={this.props.filteredProjects}
                        showAllProjects={this.props.showAllProjects}
                        loggedInUser={this.props.loggedInUser}
                        handleInputChange = {this.props.callbacks.handleInputChange}
                        showAllProjectsCallback = {this.props.callbacks.showAllProjects}
                    />
                </div>
            );
        }
    }

    renderTYPExenstionFields() {
        if (teacherSupportCategoriesWithTYPExtensionInput[this.props.chosenSupportCategory.keyword]) {
            var options = extensionReasons.map(function (reason) {
                return <option key={reason} value={reason}>{reason}</option>;
            }, this);
            return (
                <div>
                    <div className="input-holder">
                        <DatePicker
                            onSelect={this.props.callbacks.handleInputChange}
                            loggedInUser={this.props.loggedInUser}
                            requestedExtensionDate={this.parseRequestedExtensionDate()}
                            projectId={this.props.formData.proposalId}
                            dateError={this.props.formErrors.requestedExtensionDate}
                        />

                    </div>
                    <div className="input-holder">
                        <label htmlFor="extensionReason">Reason for extension:</label>
                        <select className={this.props.formErrors.extensionReason ? 'hasError' : ''}
                            name="extensionReason" id="extensionReason"
                            value={this.props.formData.extensionReason}
                            onChange={this.props.callbacks.handleInputChange}>
                            <option value="">Select one</option>
                            {options}
                        </select>
                        {this.props.formErrors.extensionReason ? (<div className="error-text">{this.props.formErrors.extensionReason}</div>) : null}
                    </div>
                    <TextField label="If other, specify:" name="otherReason" value={this.props.formData.otherReason}
                        inputChangeCallback={this.props.callbacks.handleInputChange}
                        errorMessage={this.props.formErrors.otherReason} />
                </div>
            );
        }
    }

    // Format into Month-Day-Year when JSONAdapter serializes dates as epoch longs
    parseRequestedExtensionDate() {
        var requestedExtensionDate = this.props.formData.requestedExtensionDate;
        if (requestedExtensionDate) {
            if (typeof requestedExtensionDate === 'number') {
                var date = new Date(requestedExtensionDate);
                var year = date.getUTCFullYear();
                var month = _pad(date.getUTCMonth() + 1); // getMonth is zero-indexed
                var day = _pad(date.getUTCDate()); // getDate is one-indexed

                return month + '-' + day + '-' + year;
            } else if (typeof requestedExtensionDate === 'string') {
                return requestedExtensionDate;
            } else {
                return null;
            }
        } else {
            return null;
        }
    }

    renderPromoCodeFields() {
        if (teacherSupportCategoriesWithPromoCodeInput[this.props.chosenSupportCategory.keyword]) {
            return (
                <div>
                    <div id="promoRetroactiveInputList">
                        <TextField label="Promo code" name="promoCode" value={this.props.formData.promoCode}
                            inputChangeCallback={this.props.callbacks.handleInputChange}
                            errorMessage={this.props.formErrors.promoCode} />
                        <div className="input-holder">
                            <label>Donors' email addresses</label>
                            {this.renderDonorEmailAddressFields()}
                            {this.props.formErrors.donorEmailAddresses ? (<div className="error-text">{this.props.formErrors.donorEmailAddresses}</div>) : null}
                        </div>
                    </div>
                </div>
            );
        }
    }

    renderDonorEmailAddressFields() {
        return this.props.formData.donorEmailAddresses.map((address, index) => {
            return (
                <div className="input-holder">
                    {index + 1}.&nbsp;
                    <input type="email" id={'donorEmailAddresses[' + index + ']'} name={'donorEmailAddresses[' + index + ']'} className={this.props.formErrors.donorEmailAddresses ? 'hasError' : ''} value={this.props.formData.donorEmailAddresses[index]} onChange={this.props.callbacks.handleDonorEmailAddressesChange}/>
                </div>
            );
        });
    }

    renderResourceFields() {
        if (this.props.loggedInUser && teacherSupportCategoriesWithResourceInputs[this.props.chosenSupportCategory.keyword]) {
            return (
                <div className="input-holder">
                    <ResourceSelectors
                        onSelect={this.props.callbacks.handleResourceSelectionChange}
                        handleAutoResourceSelectionChange={this.props.callbacks.handleAutoResourceSelectionChange}
                        loggedInUser={this.props.loggedInUser}
                        projectId={this.props.formData.proposalId}
                        resourceError={this.props.formErrors.resourceIds}
                        resourceIds={this.props.formData.resourceIds}
                        showResourceIssueField={teacherSupportCategoriesWithResourceIssueInputs[this.props.chosenSupportCategory.keyword]}
                        clearResourceIdsFormField = {this.props.callbacks.clearResourceIdsFormField}
                    />
                </div>
            );
        }
    }

    renderMessageField() {
        if (this.props.loggedInUser && teacherDraftableProjectCategories[this.props.chosenSupportCategory.keyword] && this.props.formData.proposalId !== 0) {
            var selectedProject = this.props.filteredProjects && this.props.filteredProjects.filter(p => p.id == this.props.formData.proposalId);
            if ((selectedProject && selectedProject.length && selectedProject[0].draftable) || !this.props.formData.proposalId) { return; }
        }

        if (!((teacherSupportCategoriesWithPromoCodeInput[this.props.chosenSupportCategory.keyword] ||
                teacherSupportCategoriesWithGiftCodeInputs[this.props.chosenSupportCategory.keyword] ||
                teacherSupportCategoriesWithTYPExtensionInput[this.props.chosenSupportCategory.keyword] ||
                (this.props.loggedInUser && teacherSupportCategoriesWithResourceIssueInputs[this.props.chosenSupportCategory.keyword]) ||
                (this.props.loggedInUser && teacherSupportCategoriesWithResourceInputs[this.props.chosenSupportCategory.keyword] && !this.props.formData.proposalId)))) {
            return (
                <div className="input-holder" id="donor-contact-message-holder">
                    <label htmlFor="message">How can we help?</label>
                    <textarea name="message" id="message" className={this.props.formErrors.message ? 'hasError' : ''} value={this.props.formData.message} onChange={this.props.callbacks.handleInputChange}/>
                    {this.props.formErrors.message ? (<div className="error-text">{this.props.formErrors.message}</div>) : null}
                </div>
            );
        }
    }

    renderGiftCodeFields() {
        if (teacherSupportCategoriesWithGiftCodeInputs[this.props.chosenSupportCategory.keyword]) {
            return (
                <div>
                    <DynamicGiftCodeInputList handleGiftCodesChange={this.props.callbacks.handleGiftCodesChange}
                        giftCodes={this.props.formData.giftCodes}
                        addGiftCodeCallback={this.props.callbacks.addGiftCodeCallback}
                        removeGiftCodeCallback={this.props.callbacks.removeGiftCodeCallback} />
                </div>
            );
        }

        return null;
    }

    trackSubmit() {
        // eslint-disable-next-line no-undef
        if (dcAnalytics) {
            // eslint-disable-next-line no-undef
            dcAnalytics.trackHelpCenter([pageName, 'teacher', 'click submit']);
            // eslint-disable-next-line no-undef
            dcAnalytics.track('Contact form', {
                formType: 'teacher',
                formAction: 'click submit',
            });
        }
    }

    // do not show teacher form fields unless category has been selected
    renderFormFields() {
        if (this.props.chosenSupportCategory.keyword) {
            if (this.props.loadingProjects) {
                return (
                    <div className="input-holder">
                        <LoadingEllipsis />
                    </div>
                );
            } else if (!this.props.loggedInUser && !teacherSupportCategoriesWithoutSignIn[this.props.chosenSupportCategory.keyword]) {
                return (<div className="error-text">Please sign in so we can further assist you.</div>);
            } else {
                return (
                    <div>
                        {this.displayFAQ()}
                        {this.renderUserInfoFields()}
                        {this.renderProjectFields()}
                        {this.renderSchoolInfoFields()}
                        {this.renderTYPExenstionFields()}
                        {this.renderPromoCodeFields()}
                        {this.renderResourceFields()}
                        {this.renderGiftCodeFields()}
                        {this.renderMessageField()}
                        <input type="submit" className="button-primary" value="Submit question" onClick={this.trackSubmit}/>
                    </div>
                );
            }
        } else {
            return (
                <div className="friendly-reminder">
                    <p>Please select an issue above so we can route your question to the right team.</p>
                </div>
            );
        }
    }

    render() {
        return (
            <form id="teacherContactForm" name="contactForm" className="form-redux" method="POST" onSubmit={this.props.callbacks.handleFormSubmit} action={secureBaseURL + 'contact/contact_form.html'}>
                <input type="hidden" id="supportCategoryId" name="supportCategoryId" value={this.props.formData.supportCategoryId}/>
                <CategorySelectors
                    supportCategories = {this.props.supportCategories}
                    tierSelectedSupportCategories = {this.props.tierSelectedSupportCategories}
                    formErrors={this.props.formErrors}
                    callbacks={this.props.callbacks}
                />
                {this.renderFormFields()}
            </form>
        );
    }
}
TeacherContactForm.propTypes = {
    formData: PropTypes.object.isRequired,
    supportCategories: PropTypes.object.isRequired,
    tierSelectedSupportCategories: PropTypes.object,
    formErrors: PropTypes.object.isRequired,
    loggedInUser: PropTypes.bool,
    projects: PropTypes.array,
    showAllProjects: PropTypes.bool,
    filteredProjects: PropTypes.array,
    loadingProjects: PropTypes.bool,
    chosenSupportCategory: PropTypes.object.isRequired,
    callbacks: PropTypes.object.isRequired,
};
